/**
 *@author shaolei
 *@date 2020/04/01
 *@file_name:header
 *@Description: 头部组件
 */
<template>
  <header>
    <div class="container">
      <el-row type="flex" class="row-bg header" justify="space-between">
        <el-col :span="4">
          <router-link
            :to="{path:'/index'}"
            class="grid-content bg-purple left"
            tag="a"
            title="韵达开放平台"
          >
            <img src="@/assets/images/company-icon.png" title="韵达开放平台" alt="韵达开放平台">
            <span>韵达开放平台</span>
          </router-link>
        </el-col>
        <el-col :span="16">
          <ul class="grid-content bg-purple-light middle">
            <router-link
              @click.native="navClick"
              :to="{ path: item.paht }"
              v-for="(item,index) in tabArry"
              :key="index"
              tag="li"
            >{{item.title}}</router-link>
            <el-menu
              id="myownMenu"
              class="el-menu-demo"
              mode="horizontal"
              background-color="#23262b"
              text-color="#333333"
              active-text-color="#333333"
            >
              <el-submenu index="0">
                <template slot="title">
                  <span>韵达科技</span>
                </template>
                <el-menu-item v-for="(item,index) in urlLink" :index="index.toString()" :key="index"  style="text-align:left">
                  <a target="_blank" :href = item.url>{{item.name}}</a>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </ul>
        </el-col>
        <el-col :span="4" v-show="!userInfo">
          <div class="grid-content bg-purple right" ref="user">
            <div class="no">
              <div class="login" @click="goLogin">登录</div>
              <div class="register" @click="register">注册</div>
            </div>
          </div>
        </el-col>
        <el-col :span="5" v-if="userInfo">
          <el-menu
            class="el-menu-demo right userBox"
            mode="horizontal"
            background-color="#ffffff"
            text-color="#333333"
            active-text-color="#333333"
            @select="handleSelect"
          >
            <el-submenu index="1" id="userSubmenu">
              <template slot="title">
                <span>{{userInfo}}</span>
              </template>
              <template slot="title">
                <img
                  @click="uerCenter"
                  v-if="userInfo"
                  class="avatar"
                  src="@/assets/images/Avatar.png"
                  alt=""
                >
              </template>
              <el-menu-item index="0">个人中心</el-menu-item>
              <el-menu-item index="2">企业认证</el-menu-item>
              <el-menu-item index="1">退出系统</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-row>
    </div>
  </header>
</template>
<script>
import { mapState } from "vuex";
import user from "@/apis/user_apis";
import utils from "@/utils/utils";
export default {
  data() {
    return {
      tabArry: [
        {
          title: "首页",
          paht: "/index"
        },
        {
          title: "API文档",
          paht: "/api"
        },
        {
          title: "控制台",
          paht: "/control"
        },
        {
          title:"解决方案",
          paht:'/Solution'
        },
        {
          title: "帮助中心",
          paht: "/help"
        }
      ],
      urlLink:[
        {name:'韵达速递官网',url:'http://www.yundaex.com/cn/index.php'},
        // {name:'韵达会员',url:'http://membernew.yundasys.com:15116/member.website/index.html'},
        {name:'东普科技',url:'http://www.dongputech.com/'}
      ],
      userInfo: '',
    };
  },
  created() {},
  mounted() {
    if (utils.getCookie("USER_INFO")) {
      this.userInfo = utils.getCookie("USER_INFO");
    }
  },
  computed: {
    // ...mapState(["userInfo"])
  },
  methods: {
    // 头部nav导航
    navClick() {
      sessionStorage.setItem("activeIndex", 0);
      sessionStorage.setItem("cdown", 0);
      document.getElementById("app").scrollTop = 0;
    },
    //登录
    goLogin() {
      this.$toast(true)
    },
    // 注册
    register() {
      this.$router.push({
        path: "/register"
      });
    },
    // 用户中心
    handleSelect(key, keyPath) {
      if (key == 0) {
        if (this.$route.path != "/account/userInfo") {
          sessionStorage.setItem("title", "账号信息");
          this.$router.push({
            name: "account",
            query: {
              name: this.userInfo
            }
          });
        }
      } else if (key == 1) {
        user.loginOut(this, this.userInfo).then(res => {
          if (res.success) {
            this.$store.commit("USER_INFO", '');
            utils.removeCookie("TOKEN");
            utils.removeCookie("USER_INFO");
            
            setTimeout(() => {
              if (this.$route.path == "/index") {
                this.userInfo = '';
              } else {
                this.userInfo = '';
                this.$router.push({
                  path: "/index"
                });
              }
              // window.location.reload();
            }, 500);
          }
        });
      } else {
        this.$router.push("/account/company");
      }
    },
    // 用户中心
    uerCenter() {
      return;
      if (this.$route.path != "/account/userInfo") {
        this.$router.push({
          name: "userInfo",
          params: {
            name: this.userInfo
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
header {
  position: fixed;
  top:0;
  z-index: 1502;
  width: 100%;
  height: 60px;
  font-size: 14px;
  line-height: 60px;
  background: rgba(35, 38, 43, 1);
  color: #f5f5f5;
  cursor: pointer;
  .left {
    display: inline-block;
    color: #fff;
    img {
      position: relative;
      top: -2px;
      width: 28px;
      height: 20px;
      margin: 0 13px 0 0;
    }
    span {
      font-size: 20px;
    }
  }
  .middle {
    display: flex;
    li {
      height: 100%;
      padding: 0 15px;
      text-align: center;
      margin-right: 35px;
    }
    & li:last-child a {
      display: inline-block;
      height: 60px;
      width: 100%;
      color: #fff;
      &:hover{
        color:#fabe00;
      }
    }

    .router-link-active {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: #fabe00;
      }
    }
  }
  .right {
    height: 60px;
    box-sizing: border-box;
    text-align: right;
    overflow: hidden;
    .no div {
      display: inline-block;
      text-align: center;
      border-radius: 2px;
      text-align: center;
    }
    span {
      color: rgba(177, 177, 177, 1);
    }
    .login {
      width: 65px;
      height: 30px;
      line-height: 30px;
      margin-right: 10px;
      background-color: #23262b;
      border: 1px solid #fabe00;
      color: #fabe00;
    }
    .register {
      width: 65px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #fabe00;
      background-color: #fabe00;
      color: #333333;
    }
    .avatar {
      width: 38px;
      height: 38px;
      border-radius: 50%;
    }
  }
  .userBox.el-menu--horizontal {
     border-bottom: none !important;
     background: #23262b !important;
    .avatar {
      position: absolute;
      right: -30px;
      top: 50%;
      margin-top: -19px;
    }
    /deep/.el-submenu__title {
        background: #23262b !important;      
    }
  }
  #myownMenu.el-menu--horizontal {
     border-bottom: none !important;
      /deep/ .el-submenu .el-submenu__title {
         background: #23262b !important;
         color: #FFFFFF !important;
         padding: 0 !important;
      }

  }
}

</style>